import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    calloutText:
      'Une fois déposé, votre objet social peut être modifié ultérieurement auprès du Greffe moyennant un coût supplémentaire. Nous vous invitons donc à remplir un objet social le plus exhaustif possible.',
    cta: 'Valider',
    explanation:
      'Voici comment cela se traduit dans votre projet de statuts, paragraphe “Objet social”.\n' +
      'Si besoin, vous pouvez modifier l’objet social ici :',
    mainActivity: 'Activité principale',
    secondaryActivities: 'Activités secondaires',
    title: 'Votre activité SASU',
  },
  fr: {
    calloutText:
      'Une fois déposé, votre objet social peut être modifié ultérieurement auprès du Greffe moyennant un coût supplémentaire. Nous vous invitons donc à remplir un objet social le plus exhaustif possible.',
    cta: 'Valider',
    explanation:
      'Voici comment cela se traduit dans votre projet de statuts, paragraphe “Objet social”.\n' +
      'Si besoin, vous pouvez modifier l’objet social ici :',
    mainActivity: 'Activité principale',
    secondaryActivities: 'Activités secondaires',
    title: 'Votre activité SASU',
  },
} as const);

export default locales;
